export default {
  denied: 'geo location permission denied',
  fail: 'geo location failed',
  timeout: 'geo location timeout'
}
